import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import Layout from "layout";
import Card from "components/card";
import Button from "components/button";
import { t } from "intl/index";
import useAppStore from "stores/appStore";

const Wrapper = styled.div`
  text-align: center;
`;

const ParticipantAlreadyAnsweredFromQr = ({ surveyId }) => {
  const { lang } = useAppStore();
  const LANG_MAP = t(lang);

  const handleBack = () => {
    const url = new URL(window.location);
    url.searchParams.set("surveyId", surveyId);
    url.searchParams.set("qr", "1");
    url.searchParams.delete("hash");
    window.location.href = url.toString();
  };

  return (
    <Layout withoutHeader={true}>
      <Card>
        <Wrapper>
          <h3>{LANG_MAP.QR_PARTICIPANT_ALREADY_ANSWERED}</h3>
          <Button onClick={handleBack} title={LANG_MAP.QR_BACK_TO_SELECTION} />
        </Wrapper>
      </Card>
    </Layout>
  );
};

ParticipantAlreadyAnsweredFromQr.propTypes = {
  surveyId: PropTypes.string.isRequired,
};

export default ParticipantAlreadyAnsweredFromQr;
